import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactStars from "react-rating-stars-component";
import Carousel from "react-bootstrap/Carousel";
import Header from "./Header";
import "./loading.css";

function MoviesList({ rating, pages, setPages, movies, setMovies, setRating }) {
  const [bestMovies, setBestMovies] = useState(null);

  const fetchData = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=c5f2c84d63771bd8924b941706200ac1&language=en-US&sort_by=sort_by=popularity.desc&include_adult=false&include_video=false&page=${
        pages + 1
      }&vote_average.gte=${
        rating * 2 - 2
      }&with_watch_monetization_types=flatrate`
    );
    setMovies([...movies, ...response.data.results]);
    setPages(pages + 1);
  };

  const topRatedMovies = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/movie/top_rated?api_key=c5f2c84d63771bd8924b941706200ac1&language=en-US&page=1`
    );
    setBestMovies(response.data.results);
  };

  useEffect(() => {
    topRatedMovies();
    // eslint-disable-next-line
  }, []);

  return movies && setMovies && bestMovies ? (
    <>
      <Header />
      <div id="scroll-target" className="container mt-5">
        <h1 className="d-flex justify-content-center mb-5">Top rated movies</h1>
        <Carousel>
          {bestMovies.map(
            (movie, index) =>
              index < 5 && (
                <Carousel.Item className="p-5">
                  <Link to={`/peliculas/${movie.id}`}>
                    <img
                      className="d-block ms-auto me-auto rounded"
                      src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`}
                      alt=""
                      style={{
                        boxShadow: "black 10px 10px 20px",
                      }}
                    />
                  </Link>
                </Carousel.Item>
              )
          )}
        </Carousel>

        <InfiniteScroll
          dataLength={movies.length} //This is important field to render the next data
          next={fetchData}
          hasMore={true}
          loader={<h4>Loading...</h4>}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
          className="row"
        >
          <div className="d-flex justify-content-center align-items-center mt-5 mb-3">
            <h2>Most popular movies</h2>
          </div>
          <div className="d-flex justify-content-center align-items-center mb-3">
            <p className="mb-0 me-3 ms-3"> Filter by rating:</p>
            <ReactStars
              count={5}
              onChange={setRating}
              size={24}
              activeColor="#ffd700"
            />
          </div>
          {movies.map((movie) => {
            return movie.poster_path ? (
              <div key={movie.id} className="col-3 mb-4 mt-4">
                <div
                  id="movie-card"
                  className=" card text-center mb-3 border-0"
                >
                  <Link to={`/peliculas/${movie.id}`} className="card-img-top">
                    <img
                      className="img-fluid rounded"
                      key={movie.id}
                      src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`}
                      alt="movie-img"
                      style={{
                        boxShadow: "black 7px 10px 10px",
                      }}
                    />
                  </Link>
                  <h2 className="mt-3">
                    <span
                      className="badge rounded-pill text-bg-warning"
                      style={{
                        boxShadow: "black 10px 10px 10px",
                      }}
                    >
                      Rating: {movie.vote_average}
                    </span>
                  </h2>
                </div>
              </div>
            ) : null;
          })}
        </InfiniteScroll>
      </div>
    </>
  ) : (
    <div className="d-flex justify-content-center align-item-center">
      <div className="loading">Loading&#8230;</div>
    </div>
  );
}
export default MoviesList;
